import { render, staticRenderFns } from "./ScoreCreateForm.vue?vue&type=template&id=35f97cda"
import script from "./ScoreCreateForm.vue?vue&type=script&lang=js"
export * from "./ScoreCreateForm.vue?vue&type=script&lang=js"
import style0 from "./ScoreCreateForm.vue?vue&type=style&index=0&id=35f97cda&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports